// extracted by mini-css-extract-plugin
export var btn = "banner-module--btn--qPoMh";
export var container = "banner-module--container--SyNXe";
export var desc = "banner-module--desc--KLQjb";
export var head = "banner-module--head--14osy";
export var img = "banner-module--img--EP-Qt";
export var section = "banner-module--section--kiQxM";